import MaxPlayer from "./MaxPlayer";

const components = {
    'max-player': MaxPlayer
}

const install = function (Vue) {
    if (install.installed) return;
    Object.keys(components).forEach(key => Vue.component(key, components[key]));
};

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

export default install
